export default {
  id: 'teams_custom',
  title: 'Custom message',
  type: 'Group / Direct',
  description: 'Create a custom message.',
  body: {
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_MESSAGE_TEXT]]</p>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  inputs: {
    INPUT_MESSAGE_TEXT: {
      label: 'Content',
      placeholder: 'Hi {{FIRST_NAME}}, ...',
      defaultValue: 'Hi {{FIRST_NAME}}, ...',
      type: 'HTML'
    }
  },
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/custom.js